module.exports = __webpack_public_path__ + "static/media/Logo_Samura.eda4e0b0.svg";